<template>
    <div class="content-wrapper-form">
        <b-modal v-model="successMsg" title="Requested Successfully" ok-only @ok="successMsg = null">
            Your request has been submitted. We will contact you ASAP.
        </b-modal>
        <b-form
            class="demo-form pt-4"
            @submit.prevent="register"
            @keydown="demoForm.onKeydown($event)"
        >

            <h1 class="text-subheader pt-0 text-center">REQUEST A DEMO</h1>
            <div class="text-caption pt-0 mb-4 text-center">Provide your information and we will contact to schedule a discovery call with our team</div>
            <div class="roles-btn">
                <b-button
                    class="btn btn-role"
                    @click="demoForm.role = mangerValue"
                    name="role"
                    id="role-option1"
                    autocomplete="off"
                    value="2"
                    v-model="demoForm.role"
                    variant="outline-secondary"
                    v-bind:class="{  active: demoForm.role === mangerValue, }">
                    Strata Manager
                </b-button>
                <b-button
                    style=""
                    class="btn btn-role"
                    @click="demoForm.role = contractorValue"
                    name="role"
                    id="role-option2"
                    autocomplete="off"
                    value="3"
                    v-model="demoForm.role"
                    variant="outline-secondary"
                    v-bind:class="{active:demoForm.role === contractorValue  }">
                    Contractor
                </b-button>
                <has-error :form="demoForm" field="role" style="position: relative; top: -10px;"></has-error>
            </div>

            <div class="form-row">
                <b-form-group class="col">
                    <b-form-input
                        type="text"
                        required
                        placeholder="Company Name"
                        v-model="demoForm.full_name"
                        v-bind:class="{'is-invalid':demoForm.errors.has('first_name')}">
                    </b-form-input>
                    <has-error :form="demoForm" field="full_name"></has-error>
                </b-form-group>
            </div>

            <b-form-group>
                <b-form-input
                    required
                    placeholder="Email"
                    v-model="demoForm.email"
                    type="text"
                    v-bind:class="{ 'is-invalid':demoForm.errors.has('email')}">
                </b-form-input>
                <has-error :form="demoForm" field="email"></has-error>
            </b-form-group>
            <b-form-group>
                <b-form-input
                    required
                    placeholder="Mobile Number (04XX-XXX-XXX)"
                    v-model="demoForm.phone"
                    type="text"
                    v-bind:class="{ 'is-invalid':demoForm.errors.has('phone')}"
                    @keyup="formatPhone">
                </b-form-input>
                <has-error :form="demoForm" field="phone"></has-error>
            </b-form-group>
            <b-form-group>
                <b-form-textarea
                    rows="5"
                    placeholder="Message"
                    v-model="demoForm.message"
                    type="text"
                    v-bind:class="{ 'is-invalid':demoForm.errors.has('message')}"
                >
                </b-form-textarea>
                <has-error :form="demoForm" field="message"></has-error>
            </b-form-group>

            <b-button
                :disabled="demoForm.busy"
                type="submit"
                variant="primary"
                class="btn-grad mx-auto"
            >Schedule a Demo</b-button>
        </b-form>
    </div>
</template>

<script>
import {Form, HasError} from "vform";
import phoneNoMixin from "../../mixins/phoneNoMixin";

Vue.component(HasError.name, HasError);

export default {
    components: {},
    mixins: [phoneNoMixin],
    data() {
        const manageValue = 'Manager';
        const contractorValue = 'Contractor';
        return {
            mangerValue:manageValue,
            contractorValue:contractorValue,
            successMsg: null,
            subPage: "register",
            sociallogin: false,
            demoForm: new Form({
                full_name: "",
                email: "",
                phone: "",
                role: null,
                message: "",
            }),
            roles: [{value: manageValue}, {value: contractorValue}],
            showPassword: false,
        };
    },
    mounted() {
    },
    methods: {
        register() {
            this.$root.$data.bsLoader = true;
            this.demoForm.post("api/demo-request").then((response) => {
                this.$root.$data.bsLoader = false;
                this.successMsg = "Your request has been submitted. We will contact you ASAP.";
                this.demoForm.reset();
            }).catch((err) => {
                this.$root.$data.bsLoader = false;
            });
        },
        formatPhone() {
            this.demoForm.phone = this.getPhoneDigitsOnly(this.demoForm.phone);
            this.demoForm.phone = this.formatPhoneForAustralia(
                this.demoForm.phone
            );
        },
        changeSubpageTo(page) {
            this.subPage = page;
        },
    },
};
</script>

<style scoped>
@media screen and (max-width: 400px) {
    .form-signin br {
        display: none;
    }

    .form-signin h2 {
        font-size: 1.5rem;
    }
}
</style>
